<template>
  <div v-if="stepsStory && shown" class="grid-cols-9 gap-12 mt-10 md:mt-24 md:grid">
    <div class="flex col-span-3 md:justify-end">
      <p class="font-semibold uppercase text-brand-orange text-tiny">harmonogram</p>
    </div>
    <div class="col-span-6">
      <p class="text-big-body"><span class="mr-1 font-semibold">Co se bude dít?</span>ShopCamp je sice {{ formattedDate}}, ale my vás
        chceme zapojit do příprav už dříve.</p>

      <p class="mt-5 md:mb-[72px] mb-12 text-big-body">Pojďte se podívat, co vás do září čeká.</p>
      <div>
        <Step ref="target" :targetIsVisible="stepVisible1" :timeType="stepTypeTime1" :title="stepTimes[0].title"
          :description="stepTimes[0].description"
          :date="formatDateTime(stepsStory.prihlasovani)">
          <a href="/prednaska/registrace"
            class="border-2 mt-0 md:mt-5 w-full justify-center md:justify-start md:w-auto mb-10 font-medium rounded-md  text-button inline-flex items-center py-[18px] md:px-[68px]"
            :class="{ 'border-brand-blue hover:opacity-80 transition-all group duration-200 text-brand-blue': happeningRegistrationOpened, 'border-brand-gray-500 cursor-not-allowed pointer-events-none text-brand-gray-500': !happeningRegistrationOpened }">
            <svg class="mr-2"
              :class="{ 'transition-all duration-200 ease-in-out text-brand-blue transform group-hover:scale-110': happeningRegistrationOpened, 'text-brand-gray-500': !happeningRegistrationOpened }"
              width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.9999 2C9.52354 2 7.49994 4.0236 7.49994 6.5C7.49994 8.9764 9.52354 11 11.9999 11C14.4763 11 16.4999 8.9764 16.4999 6.5C16.4999 4.0236 14.4763 2 11.9999 2ZM20.9316 2.50098C20.9267 2.50125 20.9218 2.50158 20.9169 2.50195C19.8535 2.54643 18.9999 3.4356 18.9999 4.5V9.39648L15.7587 12.3076C15.6209 12.4315 15.4433 12.5 15.2578 12.5H13.7499C13.6041 12.4999 13.4614 12.5424 13.3392 12.6222C13.2171 12.7019 13.1209 12.8156 13.0624 12.9492L11.9999 15.3779L11.0361 13.1768C10.9639 13.0118 10.8348 12.8784 10.6724 12.8007C10.5099 12.7231 10.325 12.7065 10.1513 12.7539C7.1827 13.5662 4.99994 16.2819 4.99994 19.5V20.5H2.24994C2.15056 20.4986 2.05188 20.517 1.95966 20.554C1.86743 20.5911 1.78349 20.6461 1.71271 20.7159C1.64194 20.7857 1.58573 20.8688 1.54737 20.9605C1.50901 21.0522 1.48926 21.1506 1.48926 21.25C1.48926 21.3494 1.50901 21.4478 1.54737 21.5395C1.58573 21.6312 1.64194 21.7143 1.71271 21.7841C1.78349 21.8539 1.86743 21.9089 1.95966 21.946C2.05188 21.983 2.15056 22.0014 2.24994 22H21.7499C21.8493 22.0014 21.948 21.983 22.0402 21.946C22.1324 21.9089 22.2164 21.8539 22.2872 21.7841C22.3579 21.7143 22.4141 21.6312 22.4525 21.5395C22.4909 21.4478 22.5106 21.3494 22.5106 21.25C22.5106 21.1506 22.4909 21.0522 22.4525 20.9605C22.4141 20.8688 22.3579 20.7857 22.2872 20.7159C22.2164 20.6461 22.1324 20.5911 22.0402 20.554C21.948 20.517 21.8493 20.4986 21.7499 20.5H18.9999V16.7891C18.9999 16.6099 19.0627 16.4384 19.1786 16.3027C19.179 16.3024 19.1793 16.3021 19.1796 16.3018L22.8193 12.0352C23.295 11.4776 23.5281 10.7524 23.4677 10.0225L22.9931 4.33398C22.9056 3.28269 21.9842 2.47786 20.9316 2.50098ZM11.9999 3.5C13.6657 3.5 14.9999 4.83426 14.9999 6.5C14.9999 8.16574 13.6657 9.5 11.9999 9.5C10.3342 9.5 8.99994 8.16574 8.99994 6.5C8.99994 4.83426 10.3342 3.5 11.9999 3.5ZM20.9716 4.00293C21.2801 3.99947 21.4747 4.17785 21.498 4.45801L21.9726 10.1465C22.0002 10.4795 21.8939 10.8081 21.6777 11.0615L18.038 15.3291C17.6905 15.7362 17.4999 16.2546 17.4999 16.7891V20.5H6.49994V19.5C6.49994 17.1885 7.95281 15.2836 9.96381 14.4678L11.3124 17.5508C11.3708 17.6846 11.4669 17.7984 11.5891 17.8784C11.7112 17.9583 11.854 18.0009 11.9999 18.0009C12.1459 18.0009 12.2887 17.9583 12.4108 17.8784C12.5329 17.7984 12.6291 17.6846 12.6874 17.5508L14.2402 14H15.2578C15.8122 14 16.3476 13.795 16.7607 13.4238C16.761 13.4238 16.7613 13.4238 16.7617 13.4238L20.2509 10.2881C20.3292 10.2178 20.3918 10.1318 20.4347 10.0358C20.4776 9.9397 20.4999 9.83568 20.4999 9.73047V4.5C20.4999 4.22747 20.7007 4.01873 20.9716 4.00293Z"
                fill="currentColor" />
            </svg>

            Chci přednášet
          </a>
        </Step>

        <Step :timeType="stepTypeTime2" :targetIsVisible="stepVisible2" :title="stepTimes[1].title"
          :description="stepTimes[1].description"
          :date="formatDateTime(stepsStory.registrace, { withTime: true })">
          <a v-show="!userLoggedIn" :href="route('frontend.registration')"
            class="mt-0 md:mt-5 mb-10 border-2 w-full md:w-auto justify-center md:justify-start font-medium rounded-md  text-button inline-flex items-center py-[18px] px-[68px]"
            :class="{ 'border-brand-blue text-brand-blue hover:opacity-80 transition-all duration-200 group': registrationPageOpened, 'cursor-not-allowed pointer-events-none border-brand-gray-500 text-brand-gray-500': !registrationPageOpened }">
            Chci přijít
            <svg class="ml-2 group-hover:translate-x-2 transform transition-all duration-200" width="24" height="24"
              viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M17.2421 5.99219C17.0929 5.99222 16.947 6.03679 16.8232 6.12019C16.6994 6.20358 16.6033 6.32202 16.5472 6.46033C16.4911 6.59865 16.4776 6.75056 16.5083 6.89662C16.539 7.04269 16.6126 7.17627 16.7197 7.28027L20.4394 11H1.74994C1.65056 10.9986 1.55188 11.017 1.45966 11.054C1.36743 11.0911 1.28349 11.1461 1.21271 11.2159C1.14194 11.2857 1.08573 11.3688 1.04737 11.4605C1.00901 11.5522 0.989258 11.6506 0.989258 11.75C0.989258 11.8494 1.00901 11.9478 1.04737 12.0395C1.08573 12.1312 1.14194 12.2143 1.21271 12.2841C1.28349 12.3539 1.36743 12.4089 1.45966 12.446C1.55188 12.483 1.65056 12.5014 1.74994 12.5H20.4394L16.7197 16.2197C16.6477 16.2888 16.5902 16.3716 16.5506 16.4632C16.511 16.5548 16.4901 16.6534 16.4891 16.7532C16.4881 16.8529 16.507 16.9519 16.5447 17.0443C16.5824 17.1367 16.6382 17.2206 16.7088 17.2912C16.7793 17.3617 16.8633 17.4175 16.9556 17.4552C17.048 17.4929 17.147 17.5118 17.2468 17.5108C17.3466 17.5098 17.4451 17.4889 17.5367 17.4493C17.6283 17.4097 17.7111 17.3523 17.7802 17.2803L22.7802 12.2803C22.9208 12.1396 22.9998 11.9489 22.9998 11.75C22.9998 11.5511 22.9208 11.3604 22.7802 11.2197L17.7802 6.21973C17.7103 6.14773 17.6267 6.0905 17.5342 6.05142C17.4418 6.01233 17.3425 5.99219 17.2421 5.99219Z"
                fill="currentColor" />
            </svg>
          </a>
          <div v-show="userLoggedIn"
            class="border-brand-gray-500 cursor-not-allowed mt-0 md:mt-5 mb-10 border-2 w-full md:w-auto justify-center md:justify-start font-medium rounded-md text-brand-gray-500 text-button inline-flex items-center py-[18px] px-[68px]">
            Již jste přihlášen/a
          </div>
        </Step>

        <Step :timeType="stepTypeTime3" :targetIsVisible="stepVisible3" :title="stepTimes[2].title"
          :description="stepTimes[2].description"
          :date="formatDateTime(stepsStory.hlasovani)">

          <a :href="route('frontend.happening-list')"
            class="mt-0 md:mt-5 mb-10 border-2 w-full md:w-auto justify-center md:justify-start font-medium rounded-md  text-button inline-flex items-center py-[18px] px-[68px]"
            :class="{ 'border-brand-blue text-brand-blue hover:opacity-80 transition-all duration-200 group': happeningVotingOpened, 'cursor-not-allowed pointer-events-none border-brand-gray-500 text-brand-gray-500': !happeningVotingOpened }">
            Chci hlasovat
            <svg class="ml-2 group-hover:translate-x-2 transform transition-all duration-200" width="24" height="24"
              viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M17.2421 5.99219C17.0929 5.99222 16.947 6.03679 16.8232 6.12019C16.6994 6.20358 16.6033 6.32202 16.5472 6.46033C16.4911 6.59865 16.4776 6.75056 16.5083 6.89662C16.539 7.04269 16.6126 7.17627 16.7197 7.28027L20.4394 11H1.74994C1.65056 10.9986 1.55188 11.017 1.45966 11.054C1.36743 11.0911 1.28349 11.1461 1.21271 11.2159C1.14194 11.2857 1.08573 11.3688 1.04737 11.4605C1.00901 11.5522 0.989258 11.6506 0.989258 11.75C0.989258 11.8494 1.00901 11.9478 1.04737 12.0395C1.08573 12.1312 1.14194 12.2143 1.21271 12.2841C1.28349 12.3539 1.36743 12.4089 1.45966 12.446C1.55188 12.483 1.65056 12.5014 1.74994 12.5H20.4394L16.7197 16.2197C16.6477 16.2888 16.5902 16.3716 16.5506 16.4632C16.511 16.5548 16.4901 16.6534 16.4891 16.7532C16.4881 16.8529 16.507 16.9519 16.5447 17.0443C16.5824 17.1367 16.6382 17.2206 16.7088 17.2912C16.7793 17.3617 16.8633 17.4175 16.9556 17.4552C17.048 17.4929 17.147 17.5118 17.2468 17.5108C17.3466 17.5098 17.4451 17.4889 17.5367 17.4493C17.6283 17.4097 17.7111 17.3523 17.7802 17.2803L22.7802 12.2803C22.9208 12.1396 22.9998 11.9489 22.9998 11.75C22.9998 11.5511 22.9208 11.3604 22.7802 11.2197L17.7802 6.21973C17.7103 6.14773 17.6267 6.0905 17.5342 6.05142C17.4418 6.01233 17.3425 5.99219 17.2421 5.99219Z"
                fill="currentColor" />
            </svg>
          </a>

          <!-- <a
      :href="route('frontend.happening-list')"
      class="mt-0 md:mt-5 mb-10 border-2 w-full md:w-auto justify-center md:justify-start font-medium rounded-md  text-button inline-flex items-center py-[18px] px-[68px]"
      :class="{'border-brand-blue text-brand-blue hover:opacity-80 transition-all duration-200 group': true}"
    >
      Výsledky hlasování
      <svg
        class="ml-2 group-hover:translate-x-2 transform transition-all duration-200"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.2421 5.99219C17.0929 5.99222 16.947 6.03679 16.8232 6.12019C16.6994 6.20358 16.6033 6.32202 16.5472 6.46033C16.4911 6.59865 16.4776 6.75056 16.5083 6.89662C16.539 7.04269 16.6126 7.17627 16.7197 7.28027L20.4394 11H1.74994C1.65056 10.9986 1.55188 11.017 1.45966 11.054C1.36743 11.0911 1.28349 11.1461 1.21271 11.2159C1.14194 11.2857 1.08573 11.3688 1.04737 11.4605C1.00901 11.5522 0.989258 11.6506 0.989258 11.75C0.989258 11.8494 1.00901 11.9478 1.04737 12.0395C1.08573 12.1312 1.14194 12.2143 1.21271 12.2841C1.28349 12.3539 1.36743 12.4089 1.45966 12.446C1.55188 12.483 1.65056 12.5014 1.74994 12.5H20.4394L16.7197 16.2197C16.6477 16.2888 16.5902 16.3716 16.5506 16.4632C16.511 16.5548 16.4901 16.6534 16.4891 16.7532C16.4881 16.8529 16.507 16.9519 16.5447 17.0443C16.5824 17.1367 16.6382 17.2206 16.7088 17.2912C16.7793 17.3617 16.8633 17.4175 16.9556 17.4552C17.048 17.4929 17.147 17.5118 17.2468 17.5108C17.3466 17.5098 17.4451 17.4889 17.5367 17.4493C17.6283 17.4097 17.7111 17.3523 17.7802 17.2803L22.7802 12.2803C22.9208 12.1396 22.9998 11.9489 22.9998 11.75C22.9998 11.5511 22.9208 11.3604 22.7802 11.2197L17.7802 6.21973C17.7103 6.14773 17.6267 6.0905 17.5342 6.05142C17.4418 6.01233 17.3425 5.99219 17.2421 5.99219Z"
          fill="currentColor"
        />
      </svg>
    </a> -->
        </Step>

        <Step :targetIsVisible="stepVisible4" :timeType="stepTypeTime4" :title="stepTimes[3].title"
          :description="stepTimes[3].description"
          :date="formatDateTime(stepsStory.program)">

        </Step>

        <Step :targetIsVisible="stepVisible5" :timeType="stepTypeTime5" :title="stepTimes[4].title"
          :description="stepTimes[4].description" :date="formatDateTime(stepsStory.showtime)" :hasLine="false">

        </Step>
      </div>
    </div>
  </div>
</template>

<script setup>

import Step from "./Step.vue";
import { ref, watch, onMounted, computed } from 'vue';
import { useIntersectionObserver, promiseTimeout } from '@vueuse/core';
import { isWithinInterval, isBefore } from 'date-fns';
import { useStoryBlokStore } from "../../stores/storyblok";
import { format } from "date-fns";
import { cs} from 'date-fns/locale';
const props = defineProps({
  happeningRegistrationOpened: {
    type: Boolean,
    default: false
  },
  registrationPageOpened: {
    type: Boolean,
    default: false
  },
  happeningVotingOpened: {
    type: Boolean,
    default: false
  },
  userLoggedIn: {
    type: Boolean,
    default: false
  },
  shopcampDate: {
    type: String,
    default: ''
  }
})
const storyBlockStore = useStoryBlokStore();

const nextFound = ref(false);
const target = ref(null)

const stepVisible1 = ref(false)
const stepVisible2 = ref(false)
const stepVisible3 = ref(false)
const stepVisible4 = ref(false)
const stepVisible5 = ref(false)

// e.g. 7. září
const formattedDate = computed(() => {
  return format(new Date(props.shopcampDate), 'd. MMMM', { locale: cs});
})

const shown = computed(() => {
  return storyBlockStore.steps.shown;
});

const stepsStory = computed(() => {
  return storyBlockStore.steps;
});

const stepTimes = computed(() => {
  return [
    {
      step: 1,
      date: new Date(stepsStory.value.prihlasovani),
      title: stepsStory.value.prihlasovani_title,
      description: stepsStory.value.prihlasovani_description,
    },
    {
      step: 2,
      date: new Date(stepsStory.value.registrace),
      title: stepsStory.value.registrace_title,
      description: stepsStory.value.registrace_description,
    },
    {
      step: 3,
      date: new Date(stepsStory.value.hlasovani),
      title: stepsStory.value.hlasovani_title,
      description: stepsStory.value.hlasovani_description,
    },
    {
      step: 4,
      date: new Date(stepsStory.value.program),
      title: stepsStory.value.program_title,
      description: stepsStory.value.program_description,
    },
    {
      step: 5,
      date: new Date(stepsStory.value.showtime),
      title: stepsStory.value.showtime_title,
      description: stepsStory.value.showtime_description,
    },
  ];
});

const stepTypeTime1 = computed(() => {
  return getTimeTypeForStep(1);
})
const stepTypeTime2 = computed(() => {
  return getTimeTypeForStep(2);
})
const stepTypeTime3 = computed(() => {
  return getTimeTypeForStep(3);
})
const stepTypeTime4 = computed(() => {
  return getTimeTypeForStep(4);
})
const stepTypeTime5 = computed(() => {
  return getTimeTypeForStep(5);
})

const { stop } = useIntersectionObserver(
  target,
  ([{ isIntersecting }], observerElement) => {
    stepVisible1.value = isIntersecting
  },
)

watch(stepVisible1, async (val, oldVal) => {
  if (val) {
    //stop observing
    stop()

    await promiseTimeout(750);
    stepVisible2.value = true;

    await promiseTimeout(750);
    stepVisible3.value = true;

    await promiseTimeout(750);
    stepVisible4.value = true;

    await promiseTimeout(750);
    stepVisible5.value = true;
  }
})

function getTimeTypeForStep(step) {
  const now = new Date();

  if (isBefore(stepTimes.value[step - 1].date, now)) {
    return 'past';
}

  if (isWithinInterval(now, { start: now, end: stepTimes.value[step - 1].date }) && !nextFound.value) {
    nextFound.value = true;
    return 'next';
  }


  return 'future';
}

function formatDateTime(storyBlockDate, { withTime = false } = {}) {
  const date = new Date(storyBlockDate);

  if (withTime) {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return date.toLocaleDateString('cs-CZ', options);
  } else {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    return date.toLocaleDateString('cs-CZ', options);
  }
}
</script>
